import { Navigate, Route, Routes } from 'react-router-dom';
import { isAuthenticated } from './lib/auth';
import { Layout } from './components/Layout';
import { HOME_PATH } from './lib/navigation';
import { DOCUMENT_LOOKUP_PATH } from './lib/document-lookup';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { QueueDetailPage } from './pages/QueueDetailPage';
import { FailedJobsPage } from './pages/FailedJobsPage';
import { BroadcastAlertPage } from './pages/BroadcastAlertPage';
import { DocumentLookupPage } from './pages/DocumentLookupPage';
import { SupportQueuePage } from './pages/SupportQueuePage';
import { SupportTicketPage } from './pages/SupportTicketPage';
import { ShopFileLayout } from './components/ShopFileLayout';
import { SHOP_FILE_BASE } from './lib/shop-file';
import { ShopSearchPage } from './pages/ShopSearchPage';
import { OverviewTab } from './pages/shop-file/OverviewTab';
import { DiagnosisTab } from './pages/shop-file/DiagnosisTab';
import { DocumentsTab } from './pages/shop-file/DocumentsTab';
import { EmailTab } from './pages/shop-file/EmailTab';
import { DatevTab } from './pages/shop-file/DatevTab';
import { BillingTab } from './pages/shop-file/BillingTab';
import { BackfillTab } from './pages/shop-file/BackfillTab';
import { PeriodBackfillTab } from './pages/shop-file/PeriodBackfillTab';
import { NumberingTab } from './pages/shop-file/NumberingTab';
import { AuditLogPage } from './pages/AuditLogPage';
import { CannedResponsesPage } from './pages/CannedResponsesPage';
import { VouchersPage } from './pages/VouchersPage';
import { SignaturePage } from './pages/SignaturePage';
import { OperationsPage } from './pages/OperationsPage';
import { OperationsInputsPage } from './pages/OperationsInputsPage';
import { InfrastructurePage } from './pages/InfrastructurePage';
import { TeamPage } from './pages/TeamPage';
import { AccountPage } from './pages/AccountPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="queue/:name" element={<QueueDetailPage />} />
        <Route path="failed-jobs" element={<FailedJobsPage />} />
        <Route path="infrastructure" element={<InfrastructurePage />} />
        <Route path="broadcast-alert" element={<BroadcastAlertPage />} />
        <Route path="support" element={<SupportQueuePage />} />
        <Route path="support/:id" element={<SupportTicketPage />} />
        <Route path={SHOP_FILE_BASE} element={<ShopSearchPage />} />
        <Route path={`${SHOP_FILE_BASE}/:shopId`} element={<ShopFileLayout />}>
          <Route index element={<OverviewTab />} />
          <Route path="diagnosis" element={<DiagnosisTab />} />
          <Route path="documents" element={<DocumentsTab />} />
          <Route path="email" element={<EmailTab />} />
          <Route path="datev" element={<DatevTab />} />
          <Route path="billing" element={<BillingTab />} />
          <Route path="backfill" element={<BackfillTab />} />
          <Route path="period-backfill" element={<PeriodBackfillTab />} />
          <Route path="numbering" element={<NumberingTab />} />
        </Route>
        <Route path={DOCUMENT_LOOKUP_PATH} element={<DocumentLookupPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="canned-responses" element={<CannedResponsesPage />} />
        <Route path="signature" element={<SignaturePage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="vouchers" element={<VouchersPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="operations/settings" element={<OperationsInputsPage />} />
      </Route>

      {/* Catch-all: where a signed-in operator starts — the ticket queue. */}
      <Route path="*" element={<Navigate to={HOME_PATH} replace />} />
    </Routes>
  );
}
